import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  getData,
  postData,
  putData,
  deleteData,
  getDownloadDataExcel,
} from "./api";
import { Per_Page_Dropdown, Select2Data, RegxExpression } from "./common";
import { formatDate } from "./apis/common/Common";
export const Context = createContext();

const AppContext = ({ children }) => {
  // const IMG_URL = " http://127.0.0.1:3999";
  const IMG_URL = "https://infinityladakhnode.profcymadev.com:1846";
  const [BookingData, setBookingData] = useState({});

  // const IMG_URL = " https://icab.node.profcyma.org:3999";

  // const IMG_URL = "https://webnode.icabtours.com:3999";
  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");

  const [userdata, setUserData] = useState({});
  const [signinGoogle, setSigninGoogle] = useState(false);
  const [Source, setSource] = useState();
  const [Destination, setDestination] = useState();

  const [date, setDate] = useState();
  const [Time, setTime] = useState();
  const [seatCapacityId, setSeatCapacityId] = useState();

  const [appSetup, setAppSetup] = useState({});
  const [isAllow, setisAllow] = useState([]);

  const [shimmerLoader, setShimmerLoader] = useState(false);
  const minLength = 2;
  const maxLength = 30;

  useEffect(() => {
    isTokenValid();
    AppSetup()
  }, [signin]);
  const AppSetup = async () => {
    const res = await getData("/without-login/app-setup");

    if (res?.success) {
      setAppSetup(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }

  }
  const isTokenValid = async () => {
    const token = Cookies.get("infinity_ladakh_web_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("infinity_ladakh_web_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
      } else {
        setisAllow(decodedToken?.permissions);
        // getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);

        await setSignin(true);
      }
    } else {
      setisAllow([]);
      await setSignin(false);
      setUsertype("");
      // navigate("/");
    }
  };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const user = urlParams.get("user");

    if (token && user) {
      Cookies.set("infinity_ladakh_web_security", token, {
        expires: 1,
      });
      setSignin(true);
      // Display the user information in the frontend
      console.log("User:", user);
    } else {
      console.log("Login failed or missing token");
    }
  }, [signinGoogle]);

  return (
    <Context.Provider
      value={{
        IMG_URL,
        getData,
        postData,
        putData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        setAppSetup,
        appSetup,
        signinGoogle,
        setSigninGoogle,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        Select2Data,
        Per_Page_Dropdown,
        RegxExpression,
        shimmerLoader,
        setShimmerLoader,
        formatDate,
        Source,
        setDestination,
        Destination,
        setSource,
        setSeatCapacityId,
        seatCapacityId,
        setTime,
        Time,
        date,
        setDate,
        BookingData,
        setBookingData,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
